import styled from 'styled-components'
import { Badge } from '@shipt/design-system-badge'
import { usePersona } from '@/features/business/hooks/usePersona'

/**
 * Renders a "Business" badge when the currently selected user group is a
 * business group. Returns `null` otherwise, so it's safe to drop into any
 * header without an extra wrapping condition.
 */
export const BusinessBadge = ({ className }: { className?: string }) => {
  const { isBusinessActive } = usePersona()

  if (!isBusinessActive) return null

  return (
    <BusinessBadgeContainer className={className}>
      <Badge size="xs" variant="neutral">
        Business
      </Badge>
    </BusinessBadgeContainer>
  )
}

const BusinessBadgeContainer = styled.span`
  display: inline-flex;
  align-items: center;
`
